import type { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { getReviewHistoryResponseDataSchema } from '../getReviewHistory/get-review-history-response';

export const getReviewHistoryV2ResponseDataSchema = getReviewHistoryResponseDataSchema;

export type IGetReviewHistoryV2ResponseData = z.infer<typeof getReviewHistoryV2ResponseDataSchema>;

export const getReviewHistoryV2ResponseSchema = createApiResponseSchema(
  getReviewHistoryV2ResponseDataSchema,
) as z.ZodSchema<IAPI<IGetReviewHistoryV2ResponseData>>;

export type IGetReviewHistoryV2Response = IAPI<IGetReviewHistoryV2ResponseData>;
